import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '../../shared/shared.module';
import {ReplacePageComponent} from './replace-page/replace-page.component';
import {RepairPageComponent} from './repair-page/repair-page.component';
import {UnknownPageComponent} from './unknown-page/unknown-page.component';
import {WizardComponent} from './wizard/wizard.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {UploadPageComponent} from './upload-page/upload-page.component';
import {WizardRoutingModule} from './wizard-routing.module';
import { UnknownRetryComponent } from './unknown-page/components/unknown-retry/unknown-retry.component';
import { UnknownHasRetriedComponent } from './unknown-page/components/unknown-has-retried/unknown-has-retried.component';
import {NoActionPageComponent} from './no-action-page/no-action-page.component';


@NgModule({
  declarations: [
    UploadPageComponent,
    ReplacePageComponent,
    RepairPageComponent,
    NoActionPageComponent,
    UnknownPageComponent,
    WizardComponent,
    ErrorPageComponent,
    UnknownRetryComponent,
    UnknownHasRetriedComponent
  ],
  imports: [
    CommonModule,
    WizardRoutingModule,
    TranslateModule,
    SharedModule
  ]
})
export class WizardModule {
}
